import qs from 'qs';
import { newAPI } from '../../../services';

export const fetchTables = async (userId, establishmentId) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/pricesitems`);
  return response.data;
}

export const createTable = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/pricesitems/new`, qs.stringify(params));
  return response.data;
}

export const updateTable = async (userId, establishmentId, params, typePrice, originalTypePrice) => {
  const formattedParams = {
    ...params,
    typePriceId: originalTypePrice,
    newTypePrice: typePrice
  }

  delete formattedParams['typePrice'];

  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/pricesitems`, qs.stringify(formattedParams));
  return response.data;
}

export const updateComponent = async (userId, establishmentId, params, typePrice) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/prices`, qs.stringify({ ...params, typeprice: typePrice }));
  return response.data;
}

export const requestRemoveTable = async (userId, establishmentId, typePrice) => {
  const response = await newAPI.delete(`${userId}/establishment/${establishmentId}/prices`, { data: qs.stringify({ typePrice }) });
  return response.data;
}

export const requestRemoveAndReplaceTable = async (userId, establishmentId, typePrice, oldTypePrice) => {
  const response = await newAPI.delete(`${userId}/establishment/${establishmentId}/prices/delete-and-replace`, { data: qs.stringify({ typePrice, oldTypePrice }) });
  return response.data;
}

export const createSpecial = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/prices/v1/special-items/new`, qs.stringify(params));
  return response.data;
}

export const updateSpecial = async (userId, establishmentId, params) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/prices/v1/special-items`, qs.stringify(params));
  return response.data;
}

export const updateCompulsary = async (userId, establishmentId, params) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/prices/v1/special`, qs.stringify(params));
  return response.data;
}

export const requestToRemoveSpecialTable = async (userId, establishmentId, params) => {
  const response = await newAPI.delete(`${userId}/establishment/${establishmentId}/prices/v1/special`, { data: qs.stringify(params) });
  return response.data;
}

export const fetchCovenant = async (userId, establishmentId, typePrice) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/covenants`, { params: { typePrice } });
  return response.data;
}

export const createCovenant = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/covenants/new`, qs.stringify(params));
  return response.data;
}

export const updateCovenant = async (userId, establishmentId, params) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/covenants`, qs.stringify(params));
  return response.data;
}